export const socialIcons = {
  facebook: require("./socials/logo-facebook-white.svg").default,
  instagram: require("./socials/logo-instagram-white.svg").default,
  youtube: require("./socials/logo-youtube-white.svg").default,
  linkedin: require("./socials/logo-linkedin-white.svg").default,
};
